import { useMemo } from 'react';
import { AccommodationHotelsQuery } from '@graphql/generated';

import { sortByFavorite, sortByOrderList } from '@shared/utils/array';
import { generateAccommodationList } from '../utils/Accommodations.utils';
import { useEventPlaces } from '@shared/utils/eventPlace';

interface GetAccommodationsDataProps {
  blockOrderingInitial?: string[] | null;
  accommodations: AccommodationHotelsQuery['eventByName'];
}

export function useSortedAccommodationsData(props: GetAccommodationsDataProps) {
  const { accommodations, blockOrderingInitial } = props;
  const { origin } = useEventPlaces();

  const allHotels = generateAccommodationList(accommodations, origin);

  const accommodationHotels = useMemo(() => sortByFavorite(sortByOrderList(allHotels ?? [], blockOrderingInitial ?? [])), [blockOrderingInitial, allHotels]);

  const hasFavoriteHotel = useMemo(() => !!(accommodationHotels && accommodationHotels.find(hotel => hotel.isFavorite)), [accommodationHotels]);

  /** Auto-populated hotels */
  const autoPopulatedHotels = useMemo(() => accommodationHotels.filter(accommodation => accommodation.autoSuggestionRecommendation != null), [accommodationHotels]);

  return { accommodationHotels, blockOrdering: accommodationHotels?.map(acc => acc.id), hasFavoriteHotel, autoPopulatedHotels };
}
